import axiosInstance from "../../../utils/axios";

const commonPath = "website";

export const GetCMSDetails = async (slug) => {
    return await axiosInstance().get(`${commonPath}/cms/page-details?slug=${slug}`);
}

export const GetServices = async () => {
    return await axiosInstance().get(`${commonPath}/cms/services`);
}